'use client';

import { Logo } from '@workspace/ui/components/custom/logo';
import { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export function RootLoading() {
  const [mounted, setMounted] = useState(false);

  useLayoutEffect(() => {
    setMounted(true);
  }, []);

  const content = (
    <div
      className="bg-grey-50/70 dark:bg-grey-1100/80 fixed inset-0 flex items-center justify-center backdrop-blur-sm"
      role="status"
      aria-live="polite"
      style={{ zIndex: 50_000, pointerEvents: 'auto' }}
    >
      <div className="relative flex flex-col items-center gap-4">
        <div className="relative p-6">
          <div
            className="absolute inset-0 animate-spin rounded-full [background:conic-gradient(from_0deg,transparent_0deg,transparent_72deg,var(--pink-100)_72deg,var(--pink-200)_144deg,var(--pink-300)_216deg,var(--pink-500)_288deg,transparent_288deg)] dark:[background:conic-gradient(from_0deg,transparent_0deg,transparent_72deg,var(--pink-300)_72deg,var(--pink-400)_144deg,var(--pink-500)_216deg,var(--pink-600)_288deg,transparent_288deg)]"
            style={{
              mask: 'radial-gradient(circle at center, transparent 60%, black 61%)',
              WebkitMask: 'radial-gradient(circle at center, transparent 60%, black 61%)',
            }}
          />
          <Logo variant="symbol" color="pink" customWidth={25} customHeight={25} />
        </div>
      </div>
    </div>
  );

  if (!mounted) return content;

  return createPortal(content, document.body);
}
